import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false,
})
export class FilterPipe implements PipeTransform {
  transform<T>(items: T[], searchText: string): T[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      // name value
      if (it['name']) {
        return it['name'].toLowerCase().includes(searchText);
      }
      if (it['value']) {
        return it['value'].toLowerCase().includes(searchText);
      }
      if (it['title']) {
        return it['title'].toLowerCase().includes(searchText);
      }
      if (it['id']) {
        return it['id'].toLowerCase().includes(searchText);
      }
      if (typeof it === 'string') {
        return it.toLowerCase().includes(searchText);
      }
      return it;
    });
  }
}
